<template>
    <div class="world-view-card">
        <AonContainer>
            <AonRow class="mt-lg">
                <AonCol class="grid-cols-12 p-0 flex-column justify-center">
                    <AonCard
                        title="World View"
                        desc="Explore the global footprint of the company's patent filings, including applications, grants, and asset inventories."
                    >
                        <template #header-append>
                            <div class="chart-action-wrapper display-flex align-items-end">
                                <p class="mr-md" style="margin-bottom: 4px">Active Patents</p>
                                <AonToggleSwitch
                                    label="All Patents"
                                    label-end
                                    :uniqueID="'world-view-patents'"
                                    :switchToggled="!entityStore.ipBasicsActivePatents"
                                    @switch="
                                        entityStore.ipBasicsActivePatents =
                                            !entityStore.ipBasicsActivePatents
                                    "
                                />
                            </div>
                        </template>
                        <div class="card-content">
                            <AonSpinner
                                v-if="entityStore.loadingEntity"
                                class="mx-auto"
                                :scale="0.5"
                                color="castleMoat"
                            />
                            <PatentCharacteristicsWorld v-else />
                        </div>
                    </AonCard>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { useEntityStore } from '@/stores'

import PatentCharacteristicsWorld from './worldView/PatentCharacteristicsWorld.vue'

const entityStore = useEntityStore()
</script>

<style lang="scss" scoped>
.world-view-card {
    width: 100%;
    position: relative;
    :deep(.a-toggle-switch label) {
        background: var(--color-moat-600) !important;
    }
}
</style>
